module.exports = __webpack_public_path__ + "img/apr-header.0f396e70.jpeg";